import { createGlobalStyle, css, DefaultTheme } from "styled-components";
import { Colors } from "./styled";

const MEDIA_WIDTHS = {
  upToXxs: 480,
  upToExtraSmall: 700,
  upToSmall: 790,
  upToMedium: 1143, //960, 1150
  upToLarge: 1280,
  mac: 1440,
};

const mediaWidthTemplates: {
  [width in keyof typeof MEDIA_WIDTHS]: typeof css;
} = Object.keys(MEDIA_WIDTHS).reduce((accumulator, size) => {
  (accumulator as any)[size] = (a: any, b: any, c: any) => css`
    @media only screen and (max-width: ${(MEDIA_WIDTHS as any)[size]}px) {
      ${css(a, b, c)}
    }
  `;
  return accumulator;
}, {}) as any;

const themeSpacing = (spacing: number | string | undefined) =>
  spacing === undefined
    ? ""
    : typeof spacing === "string"
    ? spacing
    : spacing * 4 + "px";

const fontWeight = {
  light: 300,
  regular: 400,
  bold: 500,
};

const borderRadius = {
  smallest: "8px",
  small: "12px",
  smaller: "14px",
  medium: "16px",
  larger: "18px",
  large: "20px",
  largest: "24px",
};

export const colors: Colors = {
  primary80: "#CCB846",
  primary60: "#E6CF4F",
  primary40: "#FFE658",
  primary20: "#FFF09B",
  primary00: "#FFF8CD",

  purple: "#A5A9F2",
  success: "#B6EB77",
  info: "#6A70DA",
  error: "#F47A58",
  polygonPurple: "#8247E5",

  neutral80: "#131313",
  neutral60: "#adadad",
  neutral40: "#d6d6d6",
  neutral20: "#ebebeb",
  neutral00: "#FFFFFF",
};

export const fontStyle = {
  hero1: css`
    font-size: 64px;
    font-weight: 700;
  `,
  primary: css`
    font-size: 28px;
    font-weight: 400;
  `,
  primaryBold: css`
    font-size: 28px;
    font-weight: 700;
  `,
  secondary: css`
    font-size: 24px;
    font-weight: 400;
  `,
  secondaryBold: css`
    font-size: 24px;
    font-weight: 700;
  `,
};

export const theme = (): DefaultTheme => {
  return {
    mediaWidth: mediaWidthTemplates,
    spacing: themeSpacing,
    colors,
    fontWeight,
    borderRadius,
    fontStyle,
  };
};

export const FixedGlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    image-rendering: -webkit-optimize-contrast;
    font-family: Dongle, sans-serif;
    font-size: 24px;
  }
  body {
    /* line-height: 1.5; */
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }
  input, button, textarea, select {
    font: inherit;
    outline: none;
  }
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }
  #root, #__next {
    isolation: isolate;
    height: 100%;
  }
  button, input{
    border: none;
    outline: none;
  }
  a, a:visited{
    text-decoration: none;
    color: inherit;
  }
`;
